export const addMessageShop = (messageText, publicMessage) => {
  return {
    type : 'MESSAGE_SHOP',
    messageText,
    publicMessage

  }
}; 
 